import { CoreApiResponse, IRequestEventHandler } from "../../libs/core-api-requests/common";
import { BaseDirRequest } from "../../libs/core-api-requests/dirs/baseDirRequest";
import { IContractorMotivationDTO, IContractorMotivationEditDTO, IContractorMotivationViewDTO } from "../../libs/coreapi-dto/dirs/contractorsMotivation";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common/DictionaryDataProvider";

export class ContractorMotivationDataProvider extends DictionaryDataProvider<IContractorMotivationViewDTO, IContractorMotivationDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IContractorMotivationViewDTO, IContractorMotivationDTO>> {
        return this._coreApiService.contractorMotivationRequest
    }

    getByIdContractorGlobal(idContractorGroupGlobal: string, callback: (data?: IContractorMotivationDTO, error?: any) => void) {
        this._coreApiService.contractorMotivationRequest
            .then(r => r.getByIdContractorGlobal(idContractorGroupGlobal, (e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e.data)
                }
                else {
                    const error = new Error(e.message.title);
                    (error as any).title = e.message.title;
                    callback?.(undefined, error);
                }
            })
            )
            .catch(err => {
                callback?.(undefined, err);
            });
    }

    updateByIdContractorGlobal(idGlobal: string, entity: IContractorMotivationEditDTO, callback?: () => void) {
        this._coreApiService.contractorMotivationRequest
            .then(r => {
                r.updateByIdContractorGlobal(idGlobal, entity, (e) => {
                    if (e.respType === 'isCompleted')
                        callback?.();
                    else
                        throw new Error(e.message.title);
                })
            }
            );
    }

    createByIdContractorGlobal(body: IContractorMotivationEditDTO, callback?: () => void) {
        this._coreApiService.contractorMotivationRequest
            .then(r => {
                r.createByIdContractorGlobal(body, (e) => {
                    if (e.respType === 'isCompleted')
                        callback?.();
                    else
                        throw new Error(e.message.title);
                })
            }
            );
    }
}